import { Modal } from "antd"
import { useState } from "react"

import useGlobalStore from "~/store/global"

export default function NotFound() {
  const [showModal, setShowModal] = useState(false)
  const isDarkMode = useGlobalStore((store) => store.appTheme === "dark")

  return (
    <>
      <div className="flex flex-col min-h-screen">
        <div className="relative flex items-center justify-between w-full px-3 text-13 h-12 border-b-[0.5px] dark:border-gray-200 border-light-border dark:border-b-border dark:bg-dark-1 bg-white">
          <a href="/" target="_self">
            <img
              src={
                isDarkMode
                  ? "/orbitshift_logo_white.svg"
                  : "/orbitshift_logo.svg"
              }
              alt="logo"
              width={140}
              height={33}
              className="mr-5 min-h-[33px]"
            />
          </a>
        </div>
        <div className="flex flex-col items-center justify-center flex-1 p-4 bg-gradient-to-br from-gray-50 to-gray-100 dark:from-dark-1 dark:to-dark-2 text-center">
          <div className="max-w-lg w-full">
            <div className="mb-8 flex justify-center">
              <div className="relative">
                <div className="absolute inset-0 bg-indigo-500/10 rounded-full animate-ping" />
                <div className="relative bg-gradient-to-br from-indigo-50 to-purple-50 dark:from-indigo-900/20 dark:to-purple-900/20 rounded-full p-8">
                  <svg
                    className="w-20 h-20 text-indigo-500 dark:text-indigo-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1.5}
                      d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <h1 className="text-8xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 to-purple-600 dark:from-indigo-400 dark:to-purple-500 mb-4 select-none">
              404
            </h1>
            <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-3">
              Lost in Space?
            </h2>
            <p className="text-gray-600 dark:text-gray-300 mb-8 text-base leading-relaxed">
              The page you are looking for has drifted out of orbit. Let&apos;s
              get you back on track.
            </p>
            <div className="bg-white dark:bg-dark-3 rounded-2xl shadow-lg border border-gray-200 dark:border-gray-700 p-6 mb-8">
              <div className="flex items-center justify-center space-x-2 text-sm text-gray-500 dark:text-gray-400">
                <svg
                  className="w-4 h-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <span>
                  The page you requested doesn&apos;t exist or has been moved
                </span>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href="/"
                target="_self"
                className="group relative px-6 py-3 bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white font-medium rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 flex items-center space-x-2"
                onClick={() => setShowModal(true)}
              >
                <svg
                  className="w-5 h-5 group-hover:-translate-x-1 transition-transform duration-200"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                  />
                </svg>
                <span>Back to Home</span>
              </a>
              <button
                onClick={() => {
                  setShowModal(true)
                  window.history.back()
                }}
                className="px-6 py-3 bg-white dark:bg-dark-3 text-gray-700 dark:text-gray-200 font-medium rounded-xl border-2 border-gray-200 dark:border-gray-600 hover:border-indigo-500 dark:hover:border-indigo-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-all duration-200 flex items-center space-x-2"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                <span>Go Back</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={showModal}
        closable={false}
        footer={null}
        centered
        maskClosable={false}
        keyboard={false}
        zIndex={9999}
        className="chunk-error-modal"
        styles={{
          content: {
            padding: 0,
            borderRadius: "16px",
            overflow: "hidden"
          },
          mask: {
            backdropFilter: "blur(8px)"
          }
        }}
      >
        <div className="relative overflow-hidden">
          <div
            className={`absolute inset-0 bg-gradient-to-br ${
              isDarkMode ? "from-dark-1 to-dark-2" : "from-gray-50 to-gray-100"
            }`}
          />
          <div
            className={`absolute bottom-0 left-0 w-32 h-32 rounded-full blur-3xl opacity-20 animate-pulse ${
              isDarkMode
                ? "bg-gradient-to-tr from-indigo-500/30 to-blue-500/30"
                : "bg-gradient-to-tr from-indigo-400 to-blue-500"
            }`}
            style={{ animationDelay: "1s" }}
          />
          <div className="relative text-center py-12 px-8 overflow-hidden">
            <div className="mb-8 relative">
              <div
                className={`inline-flex items-center justify-center w-24 h-24 rounded-full shadow-lg ${
                  isDarkMode
                    ? "bg-gradient-to-br from-indigo-900/30 to-purple-900/30"
                    : "bg-gradient-to-br from-indigo-50 to-purple-50"
                }`}
              >
                <div className="relative">
                  <svg
                    className={`w-10 h-10 animate-spin ${
                      isDarkMode ? "text-indigo-400" : "text-indigo-500"
                    }`}
                    fill="none"
                    viewBox="0 0 24 24"
                    style={{ animationDuration: "2s" }}
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                    />
                  </svg>
                  <div className="absolute inset-0">
                    <div
                      className={`absolute w-2 h-2 rounded-full ${
                        isDarkMode ? "bg-indigo-400" : "bg-indigo-500"
                      }`}
                      style={{
                        top: "0",
                        left: "50%",
                        transform: "translateX(-50%)",
                        animation: "orbit 2s linear infinite"
                      }}
                    ></div>
                  </div>
                </div>
              </div>
              <div
                className={`absolute inset-0 rounded-full animate-ping opacity-20 ${
                  isDarkMode ? "bg-indigo-500/20" : "bg-indigo-500/10"
                }`}
              />
            </div>
          </div>
          <div
            className={`absolute bottom-0 left-0 right-0 h-2 ${
              isDarkMode
                ? "bg-gradient-to-r from-indigo-400 to-purple-500"
                : "bg-gradient-to-r from-indigo-500 to-purple-600"
            }`}
          ></div>
        </div>
      </Modal>
    </>
  )
}
